import React, { useCallback, useMemo, useContext } from 'react'
import OptionsMenu from '../../Common/OptionsMenu/OptionsMenu'
import SectionFormContainer from '../components/SectionFormContainer'
import DaycareWizardContext from './DaycareWizardContext'
import useDaycareVisit from '../../../hooks/useDaycareVisit'
import { formatNumsToDollars } from '../../../utils'
import moment from 'moment'

const Pickup = (props) => {
	const {
		wizardContextProvider: { wizard_state, setWizardAttributeAndValues }
	} = useContext(DaycareWizardContext)
	const { attr, title = '', subtext = '' } = props
	const { loading, daycare } = useDaycareVisit()

	const handleSelection = useCallback(
		(type) => {
			const newValues = { ...wizard_state }
			newValues[attr] = type
			setWizardAttributeAndValues(newValues)
		},
		[wizard_state, setWizardAttributeAndValues, attr]
	)

	const options = useMemo(() => {
		if (!daycare) {
			return []
		}

		const o = [
			{
				title: 'Standard - Free',
				description: `Pick up by ${moment(daycare.standard_pickup_time, 'HH:mm').format('h:mma')}`,
				disabled: loading || wizard_state[attr] === false,
				selected: wizard_state[attr] === false,
				onSelected: () => handleSelection(false)
			},
			{
				title: 'Late Pick-up - Free',
				description: (
					<div>
						Pick up by {moment(daycare.late_pickup_standard_pickup_time, 'HH:mm').format('h:mma')}
					</div>
				),
				selected: wizard_state[attr] === true,
				disabled: loading || wizard_state[attr] === true,
				onSelected: () => handleSelection(true)
			}
		]

		return o
	}, [handleSelection, loading, wizard_state, attr, daycare])

	return (
		<SectionFormContainer title={title} subtext={subtext}>
			<OptionsMenu options={options} />
		</SectionFormContainer>
	)
}

export default Pickup
